<script>
import {
  defineComponent,
  inject,
  computed,
  watchEffect,
  ref,
  watch,
  nextTick,
} from "vue";
import NavMainSearch from "@kit/components/NavMainSearch.vue";
import { searchWidgetMain, navbar } from "@project/themes";
import NavBarBase from "@kit/components/NavBarBase.vue";
import IconButton from "@kit/components/IconButton.vue";
import Icon from "@kit/components/Icon.vue";
import { inBrowser } from "@kit/utils/EnvironmentHelper";
import { cmsasset } from "@kit/utils/Formats";
import { useStore } from "vuex";
import "@css/index.css";

export default defineComponent({
  name: "NavBar",
  setup() {
    const store = useStore();
    const themer = inject("themer");
    const navbarTheme = themer(navbar);
    const searchWidgetMainTheme = themer(searchWidgetMain);
    const atTop = ref(true);

    // const okToShow = computed(() => {
    //   return route.name != "contact-us" && route.name != "gtfsrt";
    // });

    // const inMobile = computed(() => {
    //   return store.state.inMobile;
    // });

    const topOn = () => {
      atTop.value = true;
    };
    const topOff = () => {
      atTop.value = false;
    };

    return {
      atTop,
      searchWidgetMainTheme,
      navbarTheme,
      cmsasset,
      topOn,
      topOff,
    };
  },
  components: {
    NavMainSearch,
    NavBarBase,
    IconButton,
    Icon,
  },
});
</script>

<style>
/*********************  

Navbar CSS 

***********************/

.navbar-outer-container--attop {
  background-image:url('/cms-static-assets/2026/04/FF335584-29D3-45D5-BBC7-D2A1D148466FL0001-xsizes-1024.jpg');
  background-position: 50% 60%;
  background-size: cover;
  background-repeat: no-repeat;
}

@media (min-width:1400px) {
 .navbar-outer-container--attop {
    background-image:url('/cms-static-assets/2026/04/FF335584-29D3-45D5-BBC7-D2A1D148466FL0001-xsizes-1024.jpg');
    background-position: 50% 55%;
    background-size: cover;
    background-repeat: no-repeat;
  } 
}

.navbar-outer-container--attop::before {
  content:"";
  position:absolute;
  left:0; 
  right:0;
  top:0;
  bottom:0;
  background-color:rgba(59, 58, 103, 0.5)
  /*
  background: linear-gradient(180deg,rgba(59, 58, 103, 0) 40%, rgba(59, 58, 103, 1) 90%);
   */

}

.navbar-inner-container {
  max-width:1200px;
}


/* Add --attop options for the nav item style */
.nav-top-option {
  cursor: pointer;
  z-index: 2;
  color: white !important;
  font-size: 1.2rem;
  font-weight: 700;
  white-space: nowrap;
  text-decoration: none;
  padding-left:20px;
  padding-right:20px;
}

.nav-top-option:hover {
  background-color:var(--nav-main-color2);  
}
.nav-dropdown-item:hover {
  background-color:var(--nav-main-color2);
}



a.nav-top-option.router-link-exact-active {
  color: white;
}

.navbar-banner-top-area {
  padding-left:20px;
  padding-top:20px;
}
.navbar-banner-top-area h1 {
  font-size:1.8rem;
  color:#FFFFFF !important;
  text-shadow: 2px 2px 3px rgba(33, 51, 84, 0.9);
}
.navbar-banner-top-area h2 {
  font-size:1.2rem;
  color:#FFFFFF !important;
  margin-top:2px;
}

.navbar-subitems > .sb {
  background: var(--nav-main-color2);
  color: #FFFFFF;
  padding: 5px 15px 5px 15px;
  font-weight: normal;
}

.fbicc-navbar-dropdown-option:hover {
  background: var(--nav-main-color1);
}

.fbicc-top-nav-routes-subitems {
  width: 300px !important;
}
.fbicc-top-nav-routes-subitems > a {
  font-size: 1rem !important;
  padding: 10px !important;
  font-weight: bold !important;
  text-decoration: none !important;
}




/* 
add --attop behavior for the nav area. We're going to 
shift it over and up so that it's one line */
.navbar-banner-nav-area {
  padding-right: 20px;
  background-color: var(--nav-main-color1);
}
.navbar-banner-nav-area.navbar-banner-nav-area--attop {
  padding-right: 20px;
  margin-top:10px;
}

.navbar-banner-top-area {
  display:none;
}
.navbar-banner-top-area.navbar-banner-top-area--attop {
  display:flex;
}

.fbicc-nav-main-searchoption {
  width: 100px !important;
}
.fbicc-nav-main-search-iconbutton {
  width: 80px !important;
}
.fbicc-nav-main-search-widget-button {
  width: 100px !important;
}

.portal-link {
  background-color: var(--portal-main-color);
  color: #ffffff !important;
  border-radius: 3px;
  border: 1px solid var(--portal-border-color);
  transition: all .2s linear;
  text-decoration: none;
  padding:15px;
}
.portal-link:hover {
  background-color:var(--portal-hover-color)
}

.fbicc-hamburger-button {
  border-top: 4px solid white;
  border-bottom: 4px solid white;
}
.fbicc-hamburger-button::after {
  background: white;
}





/* Search UI CSS */
.fbicc-search-modal-window {
  left: 0px;
  top: 0px;
  right: 0px;
  z-index: 1000;
  min-height: 335px;
  padding-top: 107px;
  padding-bottom: 50px;
  background-color: rgba(6, 42, 70, 0.92);
  background-image: linear-gradient(
    257deg,
    rgba(19, 95, 129, 0.68),
    rgba(6, 42, 70, 0.73)
  );
  opacity: 1;
}

.fbicc-main-search-widget-headline {
  font-size: 1.2em;
}

input.nav-mobile-search-input:focus,
input.nav-main-search-input:focus,
input.nav-main-search-nonmodal-input:focus {
  background-color: var(--input-area-focus-color) !important;
}

input.nav-mobile-search-input,
input.nav-main-search-input,
input.nav-main-search-nonmodal-input {
  border-style: none none solid;
  background-color: var(--input-area-regular-color);
  /* font-family: Oswald, sans-serif;
  color: #000;
  font-size: 18px;
  font-weight: 300; */
  font-size:1.2rem;
  padding: 10px !important;
}
input.nav-main-search-nonmodal-input {
  border: 2px solid var(--input-area-focus-border-color);
  border-radius: 3px;
}
@media (max-width: 960px) {
  input.nav-mobile-search-input {
    font-size: 25px;
  }
}

.nav-main-search-ui-container {
  background-color: white;
  border-radius: 5px;
}
.nav-mobile-search-ui-container {
  background-color: white;
  border-radius: 5px;
}

.nav-main-search-nonmodal-completion-ui-container {
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.5);
}

/*modal styles*/
.fbicc-search-results-prevnext-wrapper {
  padding: 0px !important;
  margin-top: 10px !important;
}
.fbicc-search-result {
  padding: 0px !important;
}
.fbicc-results-block {
  padding: 10px !important;
  background: #f2f2f2;
}

/*nonmodal widget*/
.fbicc-search-modal-search-nonmodal-button {
  width: 50px !important;
}
.fbicc-search-nonmodal-headline {
  font-weight: 400;
  color: #000000;
}

/*styles for the mobile side-nav drawer ui*/
.fbicc-mobile-search-button {
  width: 50% !important;
}
.fbicc-mobile-search-button svg {
  transform: rotate(45deg);
}
.fbicc-mobile-search-headline {
  font-size: 36px;
  line-height: 36px;
  font-weight: 400;
  color: white;
}
.fbicc-mobile-search-wrapper {
  padding-top: 20px;
  padding-right: 20px;
}
.fbicc-mobile-search-completion-wrapper,
.fbicc-main-search-completion-wrapper {
  color: black;
  font-size: 20px;
}
.fbicc-mobile-completion-result {
  padding: 7px;
}
.fbicc-main-completion-result {
  padding: 7px;
  font-size: 18px;
}
.fbicc-mobile-completion-result:hover,
.fbicc-main-completion-result:hover {
  background-color: #eeeeee;
}

</style>

<template>
  <NavBarBase @TopOn="topOn" @TopOff="topOff" :theme="navbarTheme">
    <template v-slot:top-area>
      <div class="sb sb-h sb-content-space-between">
        <div class="sb sb-v">
          <h1 class="sb sb-text">Fort Bidwell Paiute Reservation</h1>
          <h2 class="sb sb-text">Gidutikad Band</h2>
        </div>
        <div class="sb sb-v" style="padding-right:20px;">
          <a class="sb sb-text portal-link" href="https://fbcommunityportal.powerappsportals.com">Fort Bidwell Member Portal</a>
        </div>
      </div>
    </template>

    <template
      v-slot:nav-area="{ navItemClasses, dropDownNavItemClasses, navSubItemClasses }"
    >

      <div class="sb sb-h sb-greedy-1">

        <div :class="`fbicc-nav-wrapper sb sb-h sb-greedy ${ atTop ? 'sb-content-space-between' : 'sb-align-2right'}`">

          <div :class="dropDownNavItemClasses">
            About &amp; News
            <div
              :class="`${navSubItemClasses} fbicc-top-nav-routes-subitems`"
              aria-description="This is a menu showing general information and news."
              aria-role="menu"
              aria-orientation="vertical"
            >
            
                <router-link
                  class="sb fbicc-navbar-dropdown-option"
                  to="/our-history">
                  Our History
                </router-link>
                <router-link
                  class="sb fbicc-navbar-dropdown-option"
                  to="/calendar">
                  Calendar
                </router-link>
                <router-link
                  class="sb fbicc-navbar-dropdown-option"
                  to="/news">
                  News
                </router-link>

            </div>
          </div>


          <div :class="dropDownNavItemClasses">
            Gov't &amp; Facilities
            <div
              :class="`${navSubItemClasses} fbicc-top-nav-routes-subitems`"
              aria-description="This is a menu showing gov't services and local facilities."
              aria-role="menu"
              aria-orientation="vertical"
            >
            
                <!-- <router-link
                  class="sb fbicc-navbar-dropdown-option"
                  to="/government">
                  Government
                </router-link> -->
                <router-link
                  class="sb fbicc-navbar-dropdown-option"
                  to="/government/forms">
                  Forms
                </router-link>
                <router-link
                  class="sb fbicc-navbar-dropdown-option"
                  to="/housing">
                  Housing
                </router-link>
                <router-link 
                  class="sb fbicc-navbar-dropdown-option"
                  to="/wellness-center">
                  Wellness Center
                </router-link>
      
            </div>
          </div>

          <router-link to="/staff" :class="navItemClasses">Staff</router-link>

          <router-link to="/careers" :class="navItemClasses">Careers</router-link>

          <router-link to="/contact-us" :class="navItemClasses">Contact</router-link>

        </div>
        <div class="sb sb-explicit" style="width:70px;">
          <NavMainSearch :theme="searchWidgetMainTheme" />
        </div>
      </div>

   
      <!--
      <div :class="dropDownNavItemClasses">
        Routes and Services
        <div
          :class="`${navSubItemClasses} fbicc-top-nav-routes-subitems`"
          aria-description="This is a menu showing the available services from HTA."
          aria-role="menu"
          aria-orientation="vertical"
        >
          <template v-if="serviceAgencies.length > 0">
            <router-link
              v-for="serviceAgency in serviceAgencies"
              class="sb fbicc-navbar-dropdown-option"
              :to="
                serviceAgency.url
                  ? serviceAgency.url
                  : `/agencies/${serviceAgency.url_slug}`
              "
              :style="`color:${serviceAgency.final_text_color}; background-color:${serviceAgency.final_color};`"
            >
              {{ serviceAgency.display_name }}
            </router-link>
          </template>
        </div>
      </div>
      -->

    </template>
  </NavBarBase>

</template>
